import { z } from "zod";
import { DeviceSignals } from "./verify.ts";

// Device Intelligence facade input v1 (change split-core-into-trust-contexts, design D1/D2, task
// 3.1): what the Decision Engine hands to `DeviceFacade.assess` for one Interaction. The answer is
// `DeviceAssessmentV1` (assessments.ts). Serializable and strict (ADR 0001 R5); the same fields the
// SDK sends in the verify body (`sdk`, `device`, `device_ref`, `device_ref_reset`), never PII,
// location or tokens.

/**
 * The device part of the signals of one Interaction, already validated against the mode schema of
 * `POST /v1/verify`. `device_ref` is passed as received (the Device module validates it: an absent
 * or malformed value yields no `device_ref` and `device_ref_missing`).
 */
export const DeviceAssessmentInputV1 = z
  .object({
    sdk: z.object({ name: z.string().max(64), version: z.string().max(32) }).strict(),
    device: DeviceSignals,
    device_ref: z.string().max(128).optional(),
    device_ref_reset: z.boolean().optional(),
  })
  .strict()
  .meta({ id: "DeviceAssessmentInputV1" });
export type DeviceAssessmentInputV1 = z.infer<typeof DeviceAssessmentInputV1>;
